import {css} from 'styled-components';

export default css`
  font-family: 'Lato', 'Noto Sans TC', sans-serif;
  /* landing 'kepler-3-display-variable' */
  font-weight: 300;
  font-optical-sizing: auto;
  letter-spacing: 1px;
  font-style: normal;

  --primaryColor: #235ba8;
  --secondColor: #7ab1e8;
  --errorColor: #c42209;

  --icon-color: #45403f;

  /* background */
  --background-color: #f4f2ea;
  --btn-background-color: #333333;
  --profile-background-color: #cecac3;

  /* border */
  --border-color: #b8b6ad;
  --border-dark-color: #45403f;
  --table-border-color: #626060;
  --btn-border-color: #7b7a7b;
  --input-border-color: #7b7a7b;

  /* text */
  --text-1-color: #898989;
  --text-2-color: #9b9994;
  --text-3-color: #797979;
  --text-4-color: #626060;
  --text-5-color: #45403f;

  /* reverse */
  --background-reverse-color: #333333;
  --text-reverse-color: #f4f2ea;

  --topNavBarHeight: 90px;
  --border-style: solid 0.75px var(--border-color);

  background-color: var(--background-color);

  .ant-select-arrow {
    color: var(--input-border-color);
  }
  .ant-radio-inner,
  .ant-radio-inner::after {
    border-radius: 0;
  }
  input[type='date'] {
    background-color: var(--background-color);
    height: 32px;
    padding: 0 11px;
    border: 1px solid var(--input-border-color);
  }

  /* #rev-GlobalSpinner {
  } */
  #rev-ProductListPage,
  #rev-ArticleListPage {
    padding-bottom: 40px;
  }

  #rev-ProductListPage .rev-FilterMenuL2,
  #rev-ProductDetailPage .rev-FilterMenuL2 {
    position: sticky;
    top: 72px;
    margin: 0px 10px;

    & > .header {
      padding: 23px 0px;
      font-size: 1.25rem;

      & > .label {
        display: none;
      }

      &::before {
        content: '產品列表';
        flex: 1;
        font-size: 1.3rem;
      }
    }

    & > .L1 {
      background-color: transparent;
      border-radius: 0px;
      padding: 0px;
      margin-bottom: 0px;
      box-shadow: none;

      & > .header {
        padding: 10px 0;
        border-top: 1px solid #d0d0d0;
        font-size: 1rem;
        color: #000000;
      }

      & > .L1-items {
        border-top: 1px solid #d0d0d0;
        padding-left: 15px;
        overflow: hidden;

        & > .L2 {
          padding: 5px 10px;
        }

        & > .L2 > .header {
          font-size: 0.95rem;
          color: #6f6f6f;
        }

        & > .L2.selected > .header {
          font-size: 0.95rem;
          color: var(--primaryColor);
        }
      }

      &:last-child {
        border-bottom: 1px solid #d0d0d0;
      }
    }
  }

  #rev-CartPage,
  #rev-CheckoutInfoPage,
  #rev-CheckoutReviewPage {
    .container {
      max-width: inherit;
      margin-bottom: 40px;
    }
    .side > div > .detail-info {
      background-color: var(--background-color);
      border-radius: 0;
      border: solid 1px var(--border-color);
      box-shadow: none;

      & > h2,
      h4,
      .price-table > .item > h2 {
        font-size: 14px;
        font-weight: 300;
        color: var(--text-4-color);
      }

      & > h2.header {
        padding: 16px 0;
      }
      & .item {
        border-bottom: solid 1px var(--border-color);
        padding: 16px 0;
      }
      & .item:last-child {
        border: none;
      }

      & .ant-divider-inner-text {
        font-weight: 300;
      }
    }
    .step-btn,
    #checkout-btn {
      border-radius: 0;
      border: solid 1px var(--btn-border-color);
      background-color: var(--background-color);
      color: var(--text-4-color);

      &:hover {
        box-shadow: none;
      }
    }
    #checkout-btn:disabled {
      opacity: 0.5;
      &:hover {
        cursor: not-allowed;
      }
    }
    #checkout-btn:not(:disabled) {
      background-color: var(--btn-background-color);
      color: var(--text-reverse-color);
    }
  }
  .rev-CartList {
    background-color: var(--background-color);
    border-radius: 0;
    box-shadow: none;
    border: 1px solid var(--border-color);

    & > .cart-header {
      font-weight: 300;
      & > h2 {
        font-size: 16px;
        font-weight: 300;
      }
    }
    & > .cart-items-table {
      font-weight: 300;
      & > div:last-child {
        border-bottom: none;
      }

      & img.product-img {
        border-radius: 0;
      }
      & div.table-header {
        color: var(--text-4-color);
      }

      & div.table-header > .variants,
      .product-variants {
        flex: 1 0 150px;
        align-items: flex-start;
      }

      & .product-quantity > div {
        border-radius: 0;
        & > input {
          background-color: var(--background-color);
          border: none;
        }
        & > .minus-container {
          border: none;
          border-right: solid 1px var(--input-border-color);
          background-color: var(--background-color);
          color: var(--input-border-color);
        }
        & > .plus-container {
          border: none;
          border-left: solid 1px var(--input-border-color);
          background-color: var(--background-color);
          color: var(--input-border-color);
        }
      }
    }
  }

  .rev-CheckoutForm .ant-form > * {
    border: solid 1px var(--border-color);
    border-radius: 0;
    &:hover {
      box-shadow: none;
    }

    & .header {
      background-color: var(--background-color);
      padding: 16px;
      & > h2 {
        font-weight: 300;
        color: var(--text-4-color);
      }
    }
    & .content {
      border-top: solid 1px var(--border-color);
      background-color: var(--background-color);
      padding: 16px;

      & .ant-form-item-label {
        width: 120px;
        text-align: left;
        & > label {
          color: var(--text-4-color);
          font-weight: 300;
        }
        & > [for='buyer_zip']::after,
        [for='buyer_city']::after,
        [for='buyer_district']::after,
        [for='buyer_address']::after {
          display: none;
        }
      }
    }
  }

  #rev-OrderPage {
    font-weight: 300;

    & h1,
    h2 {
      /* font-weight: 300; */
      font-size: 20px;
      color: var(--text-4-color);
    }
  }
  #rev-OrderPage .first-panel,
  #rev-OrderPage .order-info-panel,
  #rev-OrderPage .logistic-panel,
  #rev-OrderPage .buyer-panel,
  #rev-OrderPage .receiver-panel,
  #rev-OrderPage .invoice-panel {
    margin-bottom: 20px;
    border: none;
    border-radius: 0;
    &:hover {
      box-shadow: none;
    }

    & .header {
      background-color: var(--profile-background-color);
      padding: 16px;
      & > h2 {
        font-weight: 300;
        font-size: 16px;
        color: var(--text-4-color);
      }
    }
    & .content {
      border-top: none;
      background-color: var(--background-color);
      padding: 16px;
      font-weight: 300;
      & label {
        color: var(--text-4-color);
      }
    }
    & .rev-CartList {
      border: none;
      padding: 0;
    }

    & .price-summary {
      & p,
      label {
        font-weight: 300;
        font-size: 14px;
      }
      & > .header {
        padding: 0;
        margin: 0;
      }
      & > .content {
        border: none;
        padding: 0;
        & > * {
          padding: 16px 0;
        }
      }
    }
  }

  .window-container {
    max-width: 1200px;
    width: 100%;
    margin: 0px auto;
    border: 1px solid var(--border-color);
    background-color: transparent;
    border-radius: 0px;

    & > .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 80px 20px;

      & > img {
        margin-bottom: 20px;
        width: 170px;
        object-fit: contain;
      }

      & > p {
        margin-bottom: 60px;
        text-align: center;
        color: var(--text-4-color);
        font-weight: 300;
      }

      & > a > button {
        cursor: pointer;
        width: 180px;
        border: solid 1px var(--btn-border-color);
        padding: 9px;
        background-color: var(--background-color);
        color: var(--text-4-color);
        border-radius: 0;

        &:hover {
          box-shadow: none;
        }
        &:active {
          box-shadow: none;
        }
      }
    }
  }

  #rev-RegisterRequestPage,
  #rev-RegisterConfirmPage {
    min-height: 100vh;

    & h2 {
      font-weight: 300;
    }
  }

  /* $$__CODEGEN_EXTRA_STYLEDCSS__$$ */
`;
